import styled from "styled-components";
import { getColor } from "~/helpers/style";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  text-align: center;
  background-color: ${getColor("background")};
`;

export const Title = styled.h1`
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 700;
  color: ${getColor("text")};
`;

export const Description = styled.p`
  margin: 0 0 24px;
  max-width: 480px;
  font-size: 16px;
  line-height: 1.5;
  color: ${getColor("textSecondary")};
`;

export const Actions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const ReloadButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  background-color: ${getColor("primary")};
  color: ${getColor("white")};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const HomeLink = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  border: 1px solid ${getColor("borderSecondary")};
  border-radius: 8px;
  background-color: ${getColor("white")};
  color: ${getColor("text")};
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    opacity: 0.9;
  }
`;
